import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  whichRecords: '',
  taxOrOwnerCount: '',
  summaryCount: '',
  commentsCount: '',
};

export const assessorMergeAndFinalizeActions = {
  async getAccessorFileMergeAndFinalize({ commit, dispatch }, {
    baseCrudKey,
  }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`{
          getAccessorFileMergeAndFinalize {
            ${fieldsToGqlString(fields)},
      }}`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      if (results.data) {
        const { getAccessorFileMergeAndFinalize } = results.data;
        commit('base/crud/setItems', [baseCrudKey, getAccessorFileMergeAndFinalize], { root: true });
      }
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting List.', { root: true });
    }
  },
  async mergeAssessorTaxRollRecordsToTaxInquiryCollection({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`{
          mergeAssessorTaxRollRecordsToTaxInquiryCollection { statusCode }
          }`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { mergeAssessorTaxRollRecordsToTaxInquiryCollection } = results.data;
      return mergeAssessorTaxRollRecordsToTaxInquiryCollection;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while merging tax/owner.', { root: true });
    }
    return {};
  },
  async pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`{
          pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress { statusCode, totalRecords }
          }`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress } = results.data;
      return pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while merging tax/owner.', { root: true });
    }
    return { statusCode: 201 };
  },
  async mergeAssessorSummaryToTaxrollSummary({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`{
          mergeAssessorSummaryToTaxrollSummary { statusCode }
          }`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { mergeAssessorSummaryToTaxrollSummary } = results.data;
      return mergeAssessorSummaryToTaxrollSummary;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while merging tax/owner.', { root: true });
    }
    return {};
  },
  async mergeAssessorCommentsToTaxComments({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`{
          mergeAssessorCommentsToTaxComments { statusCode }
          }`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { mergeAssessorCommentsToTaxComments } = results.data;
      return mergeAssessorCommentsToTaxComments;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while merging tax/owner.', { root: true });
    }
    return {};
  },
};

export default assessorMergeAndFinalizeActions;
